import {
  TextInput,
  Button,
  Group,
  Badge,
  Stack,
  ScrollArea,
  Flex,
  ScrollAreaAutosize,
} from "@mantine/core";
import { useState } from "react";
import { theme } from "../../../theme";

type DocumentType = {
  id: string;
  name: string;
};

const makeId = () => Math.random().toString(36).substring(2, 9);

const DocumentsInput = ({ form }: any) => {
  const [nameInput, setNameInput] = useState("");

  // documents yoksa boş array kullan
  const documents: DocumentType[] = form.values.documents || [];

  const addDocument = () => {
    const name = nameInput.trim();
    if (!name) return;

    const newDoc: DocumentType = {
      id: makeId(),
      name,
    };

    form.setFieldValue("documents", [...documents, newDoc]);
    setNameInput("");
  };

  const removeDocument = (id: string) => {
    form.setFieldValue(
      "documents",
      documents.filter((d) => d.id !== id)
    );
  };

  return (
    <Flex w="100%" h="100%" direction="column">
      <Group align="flex-end" wrap="nowrap" mb={10}>
        <TextInput
          label="Özlük Belgesi Adı"
          placeholder="Örn: Kimlik Fotokopisi"
          value={nameInput}
          onChange={(e) => setNameInput(e.currentTarget.value)}
          onKeyDown={(e) =>
            e.key === "Enter" && (e.preventDefault(), addDocument())
          }
          style={{ flex: 1 }}
        />
        <Button h={44} color={theme.colors.brand.normal} onClick={addDocument}>
          Ekle
        </Button>
      </Group>

      <ScrollArea
        style={{
          height: "164px",
          border: "1px solid #ddd",
          borderRadius: 6,
          paddingInline: 20,
        }}
      >
        <Stack pt={10} gap="xs">
          {documents.map((doc) => (
            <Group
              key={doc.id}
              justify="space-between"
              style={{ width: "100%" }}
            >
              <div>{doc.name}</div>
              <Button
                color="red"
                size="xs"
                variant="subtle"
                onClick={() => removeDocument(doc.id)}
              >
                Sil
              </Button>
            </Group>
          ))}
        </Stack>
      </ScrollArea>
    </Flex>
  );
};

export default DocumentsInput;
